export function initFabricApprovals() {
	try {
  const wrapper = document.querySelector('.md-fabric-approvals-table')
  if (!wrapper) return
		
		const rawData = wrapper.dataset.json;
		
		if (!rawData) {
		  throw new Error('No JSON data found in wrapper.dataset.json.');
		}
		
		if (!rawData) return;

		let dataPromise;

		// Simple check: if it looks like a URL, fetch it
		const trimmed = rawData.trim();

		// Only allow HTTP(S) URLs
		if (!/^https?:\/\//i.test(trimmed)) {
			console.error('Only URLs are allowed for JSON data.');
			return;
		}
		
		// update allowedHosts in inc/blocks.php for both enqueue_block_editor_assets and enqueue_block_assets
		const allowedHosts = (window.mdFabricApprovals && window.mdFabricApprovals.allowedHosts) || [];
		const url = new URL(trimmed);
		
		// Verify hostname is allowed
		if (!allowedHosts.includes(url.hostname)) {
			console.error('URL not allowed:', url.hostname);
			return;
		}

		// Fetch JSON safely
		dataPromise = fetch(trimmed, {
			method: 'GET',
			headers: { 'Accept': 'application/json' },
		})
			.then((res) => {
				if (!res.ok) throw new Error(`Failed to fetch JSON: ${res.status}`);
				return res.json();
			})
			.then((data) => {
				if (!Array.isArray(data)) throw new Error('Invalid JSON format');
				return data;
			})
			.catch((err) => {
				console.log(`Error loading JSON from URL:${url}`, err);
				return [];
			});

		// Sort function
		const sortByProductAndManufacturer = (arr) =>
		  arr.sort((a, b) => {
		    const productCompare = a.Product.localeCompare(b.Product, 'en', { sensitivity: 'base' });
		    if (productCompare !== 0) return productCompare;
		    return a.Manufacturer.localeCompare(b.Manufacturer, 'en', { sensitivity: 'base' });
		  });

		// Once data is ready, continue
		dataPromise.then((data) => {
			
		  // Validate and sanitize
		  if (!Array.isArray(data)) data = [];
		  data.forEach(item => {
		    item.Product = String(item.Product || '');
		    item.Manufacturer = String(item.Manufacturer || '');
		    item.Collection = String(item.Collection || '');
		    item.Textile = String(item.Textile || '');
		    item.Status = String(item.Status || '');
		  });
			
		  const sortedData = sortByProductAndManufacturer(data);
			
		  wrapper.innerHTML = `
		    <div class="md-fabric-approvals-table__filters">
		      <div class="md-fabric-approvals-table__filter-container"><select class="md-fabric-approvals-table__filter md-fabric-approvals-table__filter--products"><option value="All">All Products</option></select></div>
		      <div class="md-fabric-approvals-table__filter-container"><select class="md-fabric-approvals-table__filter md-fabric-approvals-table__filter--manufacturers" disabled><option value="All">All Manufacturers</option></select></div>
		      <div class="md-fabric-approvals-table__filter-container"><select class="md-fabric-approvals-table__filter md-fabric-approvals-table__filter--collections" disabled><option value="All">All Collections</option></select></div>
		      <div class="md-fabric-approvals-table__filter-container"><select class="md-fabric-approvals-table__filter md-fabric-approvals-table__filter--textiles" disabled><option value="All">All Textiles</option></select></div>
		      <div class="md-fabric-approvals-table__filter-container"><select class="md-fabric-approvals-table__filter md-fabric-approvals-table__filter--status" disabled><option value="All">Status</option></select></div>
					<div class="md-fabric-approvals-table__button-container"><button class="md-fabric-approvals-table__link" disabled>Reset Filters</button></div>
		    </div>
		    <table class="md-fabric-approvals-table__table">
		      <thead>
		        <tr>
		          <th>Product</th>
		          <th>Manufacturer</th>
		          <th>Collection</th>
		          <th>Textile</th>
		          <th>Status</th>
		        </tr>
		      </thead>
		      <tbody></tbody>
		    </table>
		  `;
			
			const children = [...wrapper.children];
			children.forEach(child => {
				child.classList.add('liquid-glass-content');
			});

			// Prevent duplicate insertion
			if (wrapper.querySelector('.liquid-glass-effect')) return;
			
			// add the liquid glass background
			const fragment = document.createDocumentFragment();

			['effect', 'tint', 'shine'].forEach(name => {
				const div = document.createElement('div');
				div.className = `liquid-glass-${name}`;
				fragment.appendChild(div);
			});

			if(children.length > 0) {
				children[children.length - 1].after(fragment);
			}
			
			const fabricApprovalsTable = document.querySelector('.md-fabric-approvals-table__table');
			const fabricApprovalsTableBody = document.querySelector('.md-fabric-approvals-table__table tbody');

			const fabricApprovalsProductFilter = document.querySelector('.md-fabric-approvals-table__filter--products');
			const fabricApprovalsManufacturerFilter = document.querySelector('.md-fabric-approvals-table__filter--manufacturers');
			const fabricApprovalsCollectionFilter = document.querySelector('.md-fabric-approvals-table__filter--collections');
			const fabricApprovalsTextileFilter = document.querySelector('.md-fabric-approvals-table__filter--textiles');
			const fabricApprovalsStatusFilter = document.querySelector('.md-fabric-approvals-table__filter--status');
			const fabricApprovalsResetButton = document.querySelector('.md-fabric-approvals-table__link')
			
			const FILTERS = [
				{
					key: 'Product',
					select: fabricApprovalsProductFilter,
					getValue: r => r.Product,
					filterData: false
				},
				{
					key: 'Manufacturer',
					select: fabricApprovalsManufacturerFilter,
					getValue: r => r.Manufacturer,
					filterData: true,
				},
				{
					key: 'Collection',
					select: fabricApprovalsCollectionFilter,
					getValue: r => r.Collection,
					filterData: true,
				},
				{
					key: 'Textile',
					select: fabricApprovalsTextileFilter,
					getValue: r => r.Textile,
					filterData: true,
				},
				{
					key: 'Status',
					select: fabricApprovalsStatusFilter,
					getValue: r => r.Status,
					filterData: true,
				},
			];
			
			const populateFabricApprovalsFilters = (filters, data) => {
				filters.forEach(f => {
					populateFabricApprovalsFilter(
						f.select,
						data.map(f.getValue)
					);
				});
			}
			
			const populateFabricApprovalsFilter = (select, values) => {
			  // Store current selection
			  const currentValue = select.value;

			  // Reset options but keep "All"
			  select.options.length = 1;

			  // Build unique, sorted values
			  const uniqueValues = [...new Set(values)].sort();

			  // Track whether the previous value still exists
			  let hasPreviousValue = false;

			  uniqueValues.forEach(v => {
			    const option = new Option(v, v);
			    if (v === currentValue) {
			      option.selected = true;
			      hasPreviousValue = true;
			    }
			    select.add(option);
			  });

			  // Restore previous value if possible, otherwise reset to All
			  select.value = hasPreviousValue ? currentValue : 'All';
			};
			
			function resetAllFilters() {
				FILTERS.forEach(({ select }) => {
					select.value = 'All';
				});
			}

			function resetFiltersExcept(keysToKeep = []) {
				FILTERS.forEach(({ key, select }) => {
					if (!keysToKeep.includes(key)) {
						select.value = 'All';
					}
				});
			}
			
			function applyActiveFilters(data) {
				return data.filter(row =>
					FILTERS.every(({ select, getValue }) => {
						const value = select.value;
						return value === 'All' || getValue(row) === value;
					})
				);
			}

			function renderFabricApprovalsTable(filtered) {

			  fabricApprovalsTableBody.textContent = '';

			  const seenManufacturers = new Set();
			  const seenProduct = new Set();

			  filtered.forEach(row => {
			    const tr = document.createElement('tr');

			    const manufacturer = row.Manufacturer;
			    const isFirstManufacturer = !seenManufacturers.has(manufacturer);
			    const product = row.Product;
			    const isFirstProduct = !seenProduct.has(product);

			    // Product cell
			    const tdProduct = document.createElement('td');
			    tdProduct.setAttribute('data-label', 'Product');
			    tdProduct.setAttribute('data-first', isFirstProduct);
			    tdProduct.textContent = product;

			    // Manufacturer cell
			    const tdManufacturer = document.createElement('td');
			    tdManufacturer.setAttribute('data-label', 'Manufacturer');
			    tdManufacturer.setAttribute('data-first', isFirstManufacturer);
			    tdManufacturer.textContent = manufacturer;

			    // Collection cell
			    const tdCollection = document.createElement('td');
			    tdCollection.setAttribute('data-label', 'Collection');
			    tdCollection.textContent = row.Collection;

			    // Textile cell
			    const tdTextile = document.createElement('td');
			    tdTextile.setAttribute('data-label', 'Textile');
			    tdTextile.textContent = row.Textile;

			    // Status cell
			    const tdStatus = document.createElement('td');
			    tdStatus.setAttribute('data-label', 'Status');
			    tdStatus.textContent = row.Status;

			    // Append all cells to the row
			    tr.append(tdProduct, tdManufacturer, tdCollection, tdTextile, tdStatus);

			    // Mark this manufacturer and product as seen
			    seenManufacturers.add(manufacturer);
			    seenProduct.add(product);

			    // Append the row to the table body
			    fabricApprovalsTableBody.appendChild(tr);
			  });
			}

			// Initialize dropdowns
			
			const initialFilters = FILTERS.filter(obj =>
				['Product', 'Manufacturer', 'Collection', 'Textile', 'Status'].includes(obj.key)
			);
			
			populateFabricApprovalsFilters(initialFilters, data)
			
			function applyFabricApprovalsFilters(event) {
				const changedSelect = event.target;
				const value = changedSelect.value;
				
				// filter the data based on the filter selection
				let filtered = data.filter(r => {
					let match = true;
					
					if(value === 'All') {
						return match;
					} else {
						if (changedSelect === fabricApprovalsProductFilter) {
							match = match && r.Product === value;
						}
						if (changedSelect === fabricApprovalsManufacturerFilter) {
							match = match && r.Manufacturer === value;
						}
						if (changedSelect === fabricApprovalsCollectionFilter) {
							match = match && r.Collection === value;
						}
						if (changedSelect === fabricApprovalsTextileFilter) {
							match = match && r.Textile === value;
						}
						if (changedSelect === fabricApprovalsStatusFilter) {
							match = match && r.Status === value;
						}
					}
					
					return match;
				});
				
				// Products
				if (changedSelect === fabricApprovalsProductFilter) {

					if(value === 'All') {
						
						fabricApprovalsManufacturerFilter.disabled = true;
						fabricApprovalsCollectionFilter.disabled = true;
						fabricApprovalsTextileFilter.disabled = true;
						fabricApprovalsStatusFilter.disabled = true;
						fabricApprovalsResetButton.disabled = true;
						
						fabricApprovalsTable.style.display = 'none';
						
						const filters = FILTERS.filter(obj =>
							['Product', 'Manufacturer', 'Collection', 'Textile', 'Status'].includes(obj.key)
						);
						
						populateFabricApprovalsFilters(filters, filtered)
							
						resetAllFilters();

					} else {
						
						fabricApprovalsManufacturerFilter.disabled = false;
						fabricApprovalsCollectionFilter.disabled = false;
						fabricApprovalsTextileFilter.disabled = false;
						fabricApprovalsStatusFilter.disabled = false;
						fabricApprovalsResetButton.disabled = false;
						
						filtered = applyActiveFilters(filtered);
												
						const filters = FILTERS.filter(obj =>
							['Manufacturer', 'Collection', 'Textile', 'Status'].includes(obj.key)
						);
					
						populateFabricApprovalsFilters(filters, filtered)
					}
					
					fabricApprovalsProductFilter.value = value;
				}
				
				// Manufacturers
				if (changedSelect === fabricApprovalsManufacturerFilter) {
					// show the table
					fabricApprovalsTable.style.display = 'table';

					if(value === 'All') {

						const filters = FILTERS.filter(obj =>
							['Product', 'Manufacturer', 'Collection', 'Textile', 'Status'].includes(obj.key)
						);

						populateFabricApprovalsFilters(filters, filtered)

						resetFiltersExcept(['Product']);

					} else {

						filtered = applyActiveFilters(filtered);

						const filters = FILTERS.filter(obj =>
							['Collection', 'Textile', 'Status'].includes(obj.key)
						);

						populateFabricApprovalsFilters(filters, filtered)
					}

					fabricApprovalsManufacturerFilter.value = value;

				}

				// Collections
				if (changedSelect === fabricApprovalsCollectionFilter) {
					// show the table
					fabricApprovalsTable.style.display = 'table';

					if(value === 'All') {

						const filters = FILTERS.filter(obj =>
							['Product', 'Manufacturer', 'Collection', 'Textile', 'Status'].includes(obj.key)
						);

						populateFabricApprovalsFilters(filters, filtered)
						
						resetFiltersExcept(['Product']);

					} else {

						filtered = applyActiveFilters(filtered);

						const filters = FILTERS.filter(obj =>
							['Manufacturer', 'Textile', 'Status'].includes(obj.key)
						);

						populateFabricApprovalsFilters(filters, filtered)

					}

					fabricApprovalsCollectionFilter.value = value;
				}

				// Textiles
				if (changedSelect === fabricApprovalsTextileFilter) {
					// show the table
					fabricApprovalsTable.style.display = 'table';

					if(value === 'All') {

						const filters = FILTERS.filter(obj =>
							['Product', 'Manufacturer', 'Collection', 'Textile', 'Status'].includes(obj.key)
						);

						populateFabricApprovalsFilters(filters, filtered)

						resetFiltersExcept(['Product']);

					} else {

						filtered = applyActiveFilters(filtered);

						const filters = FILTERS.filter(obj =>
							['Product', 'Manufacturer', 'Collection', 'Status'].includes(obj.key)
						);

						populateFabricApprovalsFilters(filters, filtered)
					}

					fabricApprovalsTextileFilter.value = value;
				}

				// Status
				if (changedSelect === fabricApprovalsStatusFilter) {
					// show the table
					fabricApprovalsTable.style.display = 'table';

					if(value === 'All') {

						const filters = FILTERS.filter(obj =>
							['Product', 'Manufacturer', 'Collection', 'Textile', 'Status'].includes(obj.key)
						);

						populateFabricApprovalsFilters(filters, filtered)

						resetFiltersExcept(['Product']);

					} else {

						filtered = applyActiveFilters(filtered);

						const filters = FILTERS.filter(obj =>
							['Product', 'Manufacturer', 'Collection', 'Textile'].includes(obj.key)
						);

						populateFabricApprovalsFilters(filters, filtered)
					}

					fabricApprovalsStatusFilter.value = value;
				}
				
				renderFabricApprovalsTable(filtered);
			}

			fabricApprovalsProductFilter.addEventListener('change', applyFabricApprovalsFilters);
			fabricApprovalsManufacturerFilter.addEventListener('change', applyFabricApprovalsFilters);
			fabricApprovalsCollectionFilter.addEventListener('change', applyFabricApprovalsFilters);
			fabricApprovalsTextileFilter.addEventListener('change', applyFabricApprovalsFilters);
			fabricApprovalsStatusFilter.addEventListener('change', applyFabricApprovalsFilters);
			
			fabricApprovalsResetButton?.addEventListener('click', e => {
				fabricApprovalsManufacturerFilter.disabled = true;
				fabricApprovalsCollectionFilter.disabled = true;
				fabricApprovalsTextileFilter.disabled = true;
				fabricApprovalsStatusFilter.disabled = true;
				fabricApprovalsResetButton.disabled = true;

				fabricApprovalsTable.style.display = 'none';
				
				const initialFilters = FILTERS.filter(obj =>
					['Product', 'Manufacturer', 'Collection', 'Textile', 'Status'].includes(obj.key)
				);
				
				populateFabricApprovalsFilters(initialFilters, data)
				
				resetAllFilters()
				
			})

			// Initial render
			renderFabricApprovalsTable(sortedData);
		});
	} catch (err) {
	  console.error('Error:', err.message);
	}
}

initFabricApprovals();
